import appConfig from './apiConfig';

export const AddCouponApi =( data)=>{
  
  const headers = Object.assign({'content-type':'multipart/form-data; boundary=----WebKitFormBoundary7MA4YWxkTrZu0gW',
                                 'accept':'*/*'
                             });
  const request= new Request( appConfig.siteURL+'addCoupons', {
    method : "POST",
  //  headers : headers,
    body : data
  });
  
  return fetch(request).then(response => {
      return  response.json().then(updateCouponResponse => {
        return updateCouponResponse;
      });
    }).catch(error => {
     return error;
   });
  }

  //fetchAllCouponsApi

export const fetchAllCouponsApi =(token)=>{

const headers = Object.assign({'content-type':'application/json',
                                'accept':'*/*'
                            });
const request= new Request( appConfig.siteURL+'allCouponByAdmin/'+ token, {
  method : "GET",
  headers : headers,
});

return fetch(request).then(response => {
    return  response.json().then(couponsDataResponse => {
      return couponsDataResponse;
    });
  }).catch(error => {
    return error;
  });
}





// WEBPACK FOOTER //
// ./src/api/coupon.js